export default "__VITE_ASSET__CghCR8Lf__"